import { useState } from 'react';

/** Quickly toggle boolean state */
export const useToggleState = (initialState = false) => {
  const [state, setState] = useState(initialState);
  const toggle = () => setState(!state);
  return [state, toggle];
};
